export default __webpack_public_path__ + "static/media/imagine_front.69512ea4.gif";